import type { CreditPlanSummary } from '../dtos/credit-plan';

export class CreditPlan {
  readonly id: number;
  readonly active: boolean;
  readonly name: string;
  readonly apr: number;
  readonly duration: number;
  readonly mdr: number;
  readonly notes: string;
  readonly description: string;
  readonly supplierId: number;
  readonly loanTemplateName: string;

  constructor(params: Partial<CreditPlan> & { id?: number }) {
    this.id = params.id ?? 0;
    this.active = params.active ?? false;
    this.name = params.name ?? '';
    this.apr = params.apr ?? 0;
    this.duration = params.duration ?? 0;
    this.mdr = params.mdr ?? 0;
    this.notes = params.notes ?? '';
    this.description = params.description ?? '';
    this.supplierId = params.supplierId ?? 0;
    this.loanTemplateName = params.loanTemplateName ?? '';
  }

  get durationUnit(): 'days' | 'months' {
    return this.loanTemplateName.includes('FLEX') ? 'days' : 'months';
  }

  /** Searchable text for table filtering (legacy delimiter avoids partial field matches). */
  filterText(): string {
    const parts = [
      this.name,
      this.active ? 'yes' : 'no',
      `${this.apr}%`,
      `${this.duration} ${this.durationUnit}`,
      `${this.mdr}%`,
      String(this.supplierId),
      this.loanTemplateName,
      this.description,
      this.notes,
    ];
    return parts.join('█').toLowerCase();
  }
}

export const CreditPlanMapper = {
  fromDto(dto: CreditPlanSummary): CreditPlan {
    return new CreditPlan({
      id: dto.id,
      active: dto.active,
      name: dto.name,
      apr: dto.apr,
      duration: dto.duration,
      mdr: dto.mdr,
      notes: dto.notes,
      description: dto.description,
      supplierId: dto.supplierId,
      loanTemplateName: dto.loanTemplateName,
    });
  },

  fromDtoList(dtos: CreditPlanSummary[]): CreditPlan[] {
    return (dtos ?? []).map((dto) => CreditPlanMapper.fromDto(dto));
  },
};
